<div class="card-body tab-content" id="sectionTabsContent">
    <div class="card-body tab-content" id="sectionTabsContent">

    <!-- Preview Questions -->
    <label for="" class="text-sm text-primary fw-bold">Application Form</label>
    <hr />
    <div class="accordion p-2" id="accordionExample">
      <div v-for="(section, index) in question_sections" :key="section.id" class="accordion-item my-1">
        <span class="accordion-header d-flex justify-content-between align-items-center bg-transparent"
          :id="'heading' + section.id">
          <button class="accordion-button flex-grow-1 text-start text-white bg-dark-purple " type="button" data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + section.id" aria-expanded="true"
            :aria-controls="'collapse' + section.id">
            {{ index + 1 }}. {{ section.name }}
          </button>
        </span>
        <div :id="'collapse' + section.id" class="accordion-collapse collapse"
          :aria-labelledby="'heading' + section.id">
          <div class="accordion-body">
            <div v-for="(question_section, question_index) in section.question_sections" :key="question_section.id" class="text-xs my-2">
 
              <p class="d-flex justify-content-between align-items-center  text-xs">
            <span>
                {{ question_index + 1 }}. {{ question_section.question.question }}
            </span>

            <span>
                <!--  -->
            </span>
            </p>

              <select v-if="question_section.question.question_type.question_type === 'single_select'"
                class="form-select text-xs d-md-block mr-6" :data-question_id="question.id"
                :data-question_type="question.question_type" disabled>
    
              </select>
              
              <input v-else-if="question_section.question.question_type.question_type === 'yes_no'" type="text"
                class="form-control text-xxs w-100 d-sm-block mr-6" disabled />
              <input v-else-if="question_section.question.question_type.question_type === 'number'" type="number"
                class="form-control text-xxs w-100 d-sm-block mr-6" disabled />
              <input v-else-if="question_section.question.question_type.question_type === 'file'" type="file"
                class="form-control text-xxs w-100 d-sm-block mr-6" disabled />
              <textarea v-else-if="question_section.question.question_type.question_type === 'long_text'" class="form-control mr-6" rows="2"
                disabled></textarea>
            </div>
          </div>
        </div>
      </div>
  </div>
 </div>
 </div>